import { LANGS, useI18n } from "../../util/i18n";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import panelApi from "../../util/panelApi";
import { setToast } from "../../util/toast";

// Ust bar: menu, baslik, bildirim gonder, profil.
// Bildirimler uygulamada Mesaj › Sistem Bildirimi'ne duser ve telefona yazili bildirim gider (foto yok).
const Navbar = () => {
  const { t, lang, setLang } = useI18n();
  const { admin } = useSelector((state) => state.admin);
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [form, setForm] = useState({ title: "", message: "", title_ar: "", message_ar: "", title_en: "", message_en: "", target: "all", platform: "all", userCode: "" });

  const close = () => {
    setOpen(false);
    setForm({ title: "", message: "", title_ar: "", message_ar: "", title_en: "", message_en: "", target: "all", platform: "all", userCode: "" });
  };

  const send = async (e) => {
    e.preventDefault();
    const tr = form.title.trim(), ar = form.title_ar.trim(), en = form.title_en.trim();
    if (!tr && !ar && !en) return setToast("error", "En az bir dilde başlık yaz");
    if (form.target === "one" && !form.userCode.trim()) return setToast("error", "Kullanıcı ID'si gerekli");
    setBusy(true);
    // Turkce bossa ana metin Ingilizce (o da yoksa Arapca) olur: dili bos kalan herkese o gider
    const ana = tr ? { t: form.title, m: form.message } : en ? { t: form.title_en, m: form.message_en } : { t: form.title_ar, m: form.message_ar };
    const fd = new FormData();
    Object.entries({ ...form, title: ana.t, message: ana.m }).forEach(([k, v]) => fd.append(k, v));
    const r = await panelApi.sendSystem(fd);
    setBusy(false);
    if (!r?.status) return setToast("error", r?.message || "Gönderilemedi");
    setToast("success", `Bildirim gönderildi${r.pushed != null ? ` · ${r.pushed} telefon` : ""}`);
    close();
  };

  const initials = (admin?.name || "A").trim().slice(0, 1).toUpperCase();

  return (
    <>
      <div className="sub-header-container fixed-top">
        <header className="badu-topbar">
          <div className="badu-topbar-left">
            <button
              type="button"
              className="badu-burger"
              aria-label="Menüyü aç"
              onClick={() => window.dispatchEvent(new Event("badu:menu"))}
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="6" x2="21" y2="6" />
                <line x1="3" y1="18" x2="14" y2="18" />
              </svg>
            </button>
            <Link to="/admin/dashboard" className="badu-topbar-title">
              AYVO <span>{t("Yönetim")}</span>
            </Link>
          </div>

          <div className="badu-topbar-right">
            <button type="button" className="badu-topbar-btn" onClick={() => setOpen(true)}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                <path d="M13.73 21a2 2 0 0 1-3.46 0" />
              </svg>
              <span>{t("Bildirim gönder")}</span>
            </button>
            {/* dil secici */}
            <select
              className="badu-lang"
              value={lang}
              onChange={(e) => setLang(e.target.value)}
              title={t("Dil")}
            >
              {LANGS.map((l) => (
                <option key={l.code} value={l.code}>
                  {l.flag} {l.label}
                </option>
              ))}
            </select>
            <Link to="/admin/profile" className="badu-topbar-avatar" title="Profil">
              {admin?.image ? <img src={admin.image} alt="" onError={(e) => (e.currentTarget.style.display = "none")} /> : null}
              <b>{initials}</b>
            </Link>
          </div>
        </header>
      </div>

      {open && (
        <div className="badu-modal" onClick={close}>
          <form className="badu-sheet" onClick={(e) => e.stopPropagation()} onSubmit={send}>
            <div className="badu-sheet-head">
              <div>
                <h5>Sistem bildirimi</h5>
                <p>Uygulamada Mesaj › Sistem Bildirimi'ne düşer, telefona yazılı bildirim gider.</p>
              </div>
              <button type="button" className="badu-x" onClick={close} aria-label="Kapat">
                ×
              </button>
            </div>

            <label className="badu-label">Kime</label>
            <div className="badu-seg">
              {[
                ["all", "Herkes"],
                ["users", "Kullanıcılar"],
                ["hosts", "Yayıncılar"],
                ["one", "Tek kişi"],
              ].map(([v, l]) => (
                <button type="button" key={v} className={form.target === v ? "on" : ""} onClick={() => setForm({ ...form, target: v })}>
                  {l}
                </button>
              ))}
            </div>

            {form.target !== "one" && (
              <>
                <label className="badu-label">Telefon</label>
                <div className="badu-seg">
                  {[
                    ["all", "Hepsi"],
                    ["android", "Android"],
                    ["ios", "iPhone"],
                  ].map(([v, l]) => (
                    <button type="button" key={v} className={form.platform === v ? "on" : ""} onClick={() => setForm({ ...form, platform: v })}>
                      {l}
                    </button>
                  ))}
                </div>
              </>
            )}

            {form.target === "one" && (
              <>
                <label className="badu-label">Kullanıcı ID</label>
                <input className="form-control" placeholder="ör. 6030548" value={form.userCode} onChange={(e) => setForm({ ...form, userCode: e.target.value })} />
              </>
            )}

            <p style={{ fontSize: 12, color: "#6B7280", margin: "6px 0 2px" }}>
              Her kullanıcıya kendi uygulama dilindeki metin gider. Boş bıraktığın dil, doldurduğun ilk dile düşer.
            </p>
            {[
              ["", "🇹🇷 Türkçe", "ör. Hafta sonu etkinliği başladı", "Kısa ve net bir açıklama", "ltr"],
              ["_ar", "🇸🇦 العربية (Arapça)", "مثال: بدأت فعالية نهاية الأسبوع", "وصف قصير وواضح", "rtl"],
              ["_en", "🇬🇧 English (İngilizce)", "e.g. Weekend event has started", "A short, clear description", "ltr"],
            ].map(([k, ad, pt, pm, dir]) => (
              <div key={k || "tr"} style={{ border: "1px solid #E5E7EB", borderRadius: 12, padding: "10px 12px 6px", marginTop: 10 }}>
                <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 6 }}>{ad}</div>
                <input
                  className="form-control"
                  dir={dir}
                  maxLength={80}
                  placeholder={pt}
                  value={form["title" + k]}
                  onChange={(e) => setForm({ ...form, ["title" + k]: e.target.value })}
                />
                <textarea
                  className="form-control"
                  dir={dir}
                  rows={3}
                  maxLength={240}
                  style={{ marginTop: 6 }}
                  placeholder={pm}
                  value={form["message" + k]}
                  onChange={(e) => setForm({ ...form, ["message" + k]: e.target.value })}
                />
                <div className="badu-count">{form["message" + k].length}/240</div>
              </div>
            ))}

            <div className="badu-sheet-actions">
              <button type="button" className="btn btn-light" onClick={close}>
                Vazgeç
              </button>
              <button type="submit" className="btn btn-primary" disabled={busy}>
                {busy ? "Gönderiliyor…" : "Gönder"}
              </button>
            </div>
          </form>
        </div>
      )}
    </>
  );
};

export default Navbar;
